<template>
  <div id="wrapper">

    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li class="active">
                <span>Manage Users</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Manage Users
          </h3>
          <small>You can manage users who attached with you</small>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="row">
        <div class="col-lg-12">
          <div class="hpanel">

            <div class="panel-heading">
              Attached users

              <div class="pull-right text-right">
                <div class="btn-group">
                  <router-link v-if="$auth.user().plan.account_provisioning === 1" class="btn btn-outline btn-success btn-xs" :to="{name: 'CreateUser'}"> <i class="fa fa-plus"></i> New user</router-link>
                  <button v-else class="btn btn-outline btn-success btn-xs" @click="$refs.limitPlan.show('new_user')"> <i class="fa fa-plus"></i> New user</button>
                </div>
              </div>

            </div>

            <div class="panel-body">
              <div class="">
                <div class="table-responsive" style="border: 0">

                  <table id="userTable" class="table table-striped table-bordered table-hover " style="font-size: 10px;width: 100%">
                    <thead>
                    <tr>
                      <th>#Ref</th>
                      <th>FirstName</th>
                      <th>LastName</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Company</th>
                      <th>Role</th>
                      <th>Plan</th>
                      <th>Profile</th>
                      <th>Last Login</th>
                      <th>Status</th>
                      <th>Supervisor</th>
                      <th>Created</th>
                      <th v-if="$auth.user().plan.account_provisioning === 1">Action</th>

                    </tr>
                    </thead>
                  </table>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
    <limit-plan ref="limitPlan"></limit-plan>

  </div>
</template>

<style>
  .btnDisable, .btnEnable {
    font-size: 13px;
    padding: 0px 3px
  }
</style>

<script>
import 'datatables.net-bs/css/dataTables.bootstrap.min.css'
import 'datatables/media/js/jquery.dataTables.min'
import 'datatables.net-bs/js/dataTables.bootstrap.min'
import LimitPlan from '../../components/LimitPlan'

export default {
  components: {LimitPlan},
  name: 'UsersList',
  methods: {
  },
  data () {
    return {
      dataTable: null,
      users: []
    }
  },
  mounted () {
    let customColumnDefs = []
    if (this.$auth.user().plan.account_provisioning === 1) {
      customColumnDefs.push({
        targets: 13,
        data: null,
        searchable: false,
        defaultContent: '<router-link  class="btn btn-xs btn-block btn-info btn-outline editUser">' +
          '<i class="fas fa-pencil-alt"></i> Edit </router-link>'
      })
    }

    var dataTable = $('#userTable').DataTable({
      responsive: true,
      processing: true,
      serverSide: true,
      bPaginate: true,
      ajax: {
        url: process.env.API_URL + '/consultant/users?relations={profile,company,supervisor,planCredit.plan,roles}',
        dataSrc: 'data',
        // beforeSend: config
        beforeSend: function (request) {
          request.setRequestHeader('Authorization', 'Bearer ' + localStorage.default_auth_token
          )
        }
      },
      columns: [
        {data: 'id'},
        {data: 'firstname'},
        {data: 'lastname'},
        {data: 'email'},
        {data: 'phone'},
        {data: 'company', name: 'company.name'},
        {data: 'role', name: 'roles.name', orderable: false},
        {data: 'plan', name: 'planCredit.plan.name', searchable: false},
        {data: 'profile', name: 'profile.name'},
        {data: 'last_login'},
        {data: 'enabled'},
        {data: 'supervisor', name: 'supervisor.lastname', searchable: false, orderable: false},
        {data: 'created_at'}

      ],
      columnDefs: customColumnDefs,
      createdRow: function (row, data, index) {
        let td = $('td', row).eq(10)
        if (data['enabled'] * 1 > 0) {
          td.html('<span class="btn-success btnEnable"><i class="fa fa-check"></i></span>')
        } else {
          td.html('<span class="btn-danger btnDisable" ><i class="fa fa-times"></i></span>')
        }
        td.attr('align', 'center')
      },
      buttons: [
        {extend: 'copy', className: 'btn-sm'},
        {extend: 'csv', title: 'ExampleFile', className: 'btn-sm'},
        {extend: 'pdf', title: 'ExampleFile', className: 'btn-sm'},
        {extend: 'print', className: 'btn-sm'}
      ]
    })

    let self = this
    $('#userTable tbody').on('click', '.editUser', function () {
      let data = dataTable.row($(this).parents('tr')).data()
      self.$router.push({name: 'ManageUser', params: {id: data['id']}})
    })
  },
  updated: function () {
    this.$nextTick(function () {
    })
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/manageUsers/UsersList.vue